import React from 'react';
import { Card, Badge, ListGroup } from 'react-bootstrap';
import SubwayMap from './SubwayMap';

const WorkflowCard = ({ workflow, referenceWorkflow }) => {
  const getConfidenceColor = (confidence) => {
    if (confidence >= 0.9) return 'success';
    if (confidence >= 0.8) return 'warning';
    return 'danger';
  };

  return (
    <Card className="mb-1 shadow-sm">
      <Card.Header className="bg-white py-1 px-2">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h5 className="mb-0" style={{fontSize: '1.1rem'}}>{workflow.name}</h5>
            <small className="text-muted" style={{fontSize: '0.8rem'}}>Source: {workflow.source}</small>
          </div>
          <div className="text-end">
            <Badge bg={getConfidenceColor(workflow.confidence)} className="mb-0" style={{fontSize: '0.75rem'}}>
              {Math.round(workflow.confidence * 100)}% Confidence
            </Badge>
            <div style={{fontSize: '0.85rem'}}>
              <strong className="text-primary">{workflow.frequency}</strong>
              <small className="text-muted"> occurrences</small>
            </div>
            <div>
              <small className="text-muted" style={{fontSize: '0.75rem'}}>{workflow.percentage}% of total</small>
            </div>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="py-1 px-2">
        <SubwayMap
          steps={workflow.steps}
          connections={workflow.connections}
          variant="detected"
          referenceWorkflow={referenceWorkflow}
        />
        
        <div className="mt-1">
          <h6 className="mb-0" style={{fontSize: '0.95rem', fontWeight: '600'}}>Key Differences:</h6>
          <ul className="list-unstyled mb-0" style={{fontSize: '0.85rem'}}>
            {workflow.differences.map((diff, idx) => (
              <li key={idx} className="mb-0">
                <i className="bi bi-arrow-right-circle text-danger me-1"></i>
                {diff}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-1">
          <h6 className="mb-0" style={{fontSize: '0.95rem', fontWeight: '600'}}>Detected From:</h6>
          <ListGroup variant="flush">
            {workflow.detectedFrom.map((source, idx) => (
              <ListGroup.Item key={idx} className="px-0">
                <div className="d-flex justify-content-between">
                  <span>
                    <Badge bg="secondary" className="me-2">{source.system}</Badge>
                    {source.events} events
                  </span>
                  <small className="text-muted">Last seen: {source.lastSeen}</small>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </Card.Body>
    </Card>
  );
};

export default WorkflowCard;

